// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {WBSearchableSelect} from '../elements/WBSearchableSelect';
import * as WBSearchableSelectStyles from '../elements/WBSearchableSelect.styles';

export const NumRuns = styled.div`
  float: right;
  margin-right: 15px;
`;

export const NumRunsText = styled.span`
  font-size: 13px;
  font-style: italic;
`;

export const StyledSearchableSelect = styled(WBSearchableSelect)`
  ${WBSearchableSelectStyles.SearchableInput} {
    border: none;
    background: none;
  }
`;
